















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import SelectionBox from '@/componentsV2/molecules/Inputs/SelectionBox.vue';
import Both from '@/components/icons/BothStore.vue';
import Online from '@/components/icons/OnlineStore.vue';
import InStore from '@/components/icons/InStore.vue';
import { IBusinessType } from '@/models/business';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

@Component({
  components: { SelectionBox, Both, InStore, Online, Typography }
})
export default class SelectLoyaltyReward extends Vue {
  @Prop() defaultValue?: string;
  @Prop() showDisclaimerBoth?: string;
  @Prop({ default: () => Boolean }) filterOptions!: (item: any) => boolean;

  options: { label: string; value: string; icon: string }[] = [];

  selected = this.defaultValue || '';

  IBusinessType = IBusinessType;

  @Watch('selected')
  changeSelected() {
    this.$emit('input', this.selected);
  }

  created() {
    this.options = [
      {
        label: 'Set up rewards for your <b>In-Store</b> members.',
        value: IBusinessType.INSTORE,
        icon: 'InStore'
      },
      {
        label: 'Set up rewards for your <b>Online</b> members.',
        value: IBusinessType.ONLINE,
        icon: 'Online'
      },
      {
        label: 'Set up rewards for your <b>In-Store & Online</b> members.',
        value: IBusinessType.BOTH,
        icon: 'Both'
      }
    ].filter(this.filterOptions);
  }
}
